export default __webpack_public_path__ + "static/media/animacion-referidos.f6dd55ec.gif";